import React, {PureComponent} from 'react'
import injectSheet, {withTheme} from 'react-jss'
import CardGrid from "../Card/CardGrid"
import Section from "../Widgets/Section"
import SectionTitle from "../Widgets/SectionTitle"
import BackgroundContrastContainer from "../LandingPage/BackgroundContrastContainer"

class RelatedLookbooks extends PureComponent {

    render() {
        const {theme, related_articles} = this.props;
        if(! related_articles || !related_articles.length ) return null;

        return (
          <BackgroundContrastContainer applyContrast>
            <SectionTitle text='Lookbooks' color={theme.colors.lookbooks} />
            <Section key='articles'>
                <CardGrid columns={4} items={related_articles} singleLine={true} showSummary={false} variation='vertical'/>
            </Section>
          </BackgroundContrastContainer>
        )
    }
}

export default injectSheet( (theme) => ({

}))(withTheme(RelatedLookbooks))





// WEBPACK FOOTER //
// ./src/components/Lookbook/RelatedLookbooks.js